"use strict";
// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Humla Health API
 * Humla Health API
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.OrientationOpportunityMatchType = void 0;
exports.instanceOfOrientationOpportunityMatchType = instanceOfOrientationOpportunityMatchType;
exports.OrientationOpportunityMatchTypeFromJSON = OrientationOpportunityMatchTypeFromJSON;
exports.OrientationOpportunityMatchTypeFromJSONTyped = OrientationOpportunityMatchTypeFromJSONTyped;
exports.OrientationOpportunityMatchTypeToJSON = OrientationOpportunityMatchTypeToJSON;
exports.OrientationOpportunityMatchTypeToJSONTyped = OrientationOpportunityMatchTypeToJSONTyped;
/**
 * FULL when the nurse meets every work requirement and can be scheduled now; PARTIAL when they cannot be scheduled yet. That covers nurses who are licensed in the state and claim the specialty but have administrative items outstanding, and nurses who asked for this orientation but no longer meet every requirement.
 * @export
 */
exports.OrientationOpportunityMatchType = {
    Full: 'FULL',
    Partial: 'PARTIAL'
};
function instanceOfOrientationOpportunityMatchType(value) {
    for (const key in exports.OrientationOpportunityMatchType) {
        if (Object.prototype.hasOwnProperty.call(exports.OrientationOpportunityMatchType, key)) {
            if (exports.OrientationOpportunityMatchType[key] === value) {
                return true;
            }
        }
    }
    return false;
}
function OrientationOpportunityMatchTypeFromJSON(json) {
    return OrientationOpportunityMatchTypeFromJSONTyped(json, false);
}
function OrientationOpportunityMatchTypeFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
function OrientationOpportunityMatchTypeToJSON(value) {
    return value;
}
function OrientationOpportunityMatchTypeToJSONTyped(value, ignoreDiscriminator) {
    return value;
}
//# sourceMappingURL=OrientationOpportunityMatchType.js.map